import $ from 'jQuery';

$(function () {
    $('.county').on('mouseenter', function () {
        $(this).addClass('active');

        var sizeY = $('.region-map__map_hover').height();
        var sizeX = $('.region-map__map_hover').width();

        var pathY = this.getBoundingClientRect().height;
        var pathX = this.getBoundingClientRect().width;

        var posY = $(this).offset().top - sizeY + pathY / 2 - 30;
        var posX = $(this).offset().left - (sizeX - pathX) / 2;

        $('.region-map__map_hover').css({
            top: posY,
            left: posX,
        });

        var href = $(this).parent().attr('href');
        var regionId = $(this).parent().data('id');
        $('.region-map__map_hover').attr('href', href);
        $('.region-map__map_hover ' + regionId).addClass('active');
        $('.region-map__map_hover').addClass('active');
    });

    $('.county').on('mouseleave', function () {
        if ($('.region-map__map_hover').filter(':hover').length == 0) {
            $('.region-map__map_hoverData.active').removeClass('active');
            $('.region-map__map_hover').removeClass('active');
            $(this).removeClass('active');
        }
    });

    $('.region-map__map_hover').on('mouseleave', function () {
        $('.region-map__map_hoverData.active').removeClass('active');
        $('.region-map__map_hover').removeClass('active');
        $('.county.active').removeClass('active');
    });
});
